<template>
  <section class='page-powerIndustry'>
    <resolution :current="powerIndustry"/>
  </section>
</template>

<script>
import resolution from './index.vue'
import { CONSOLE_SITE_URL } from '@/utils/constants';
export default {
  metaInfo: {
  title: '电力行业解决方案_远程监管_马兰头医学科技',
  meta: [
    {
      name: 'keywords',
      content: '生产检修管理，远程业务监管，电力行业解决方案'
    },
    {
      name: 'description',
      content: '针对电力行业，提供生产检修管理、智能监管等系统平台解决方案，帮助电网各级管理者掌握设备及其运维状态、提高电网在可靠性、技术、远程协同等方面的精益化管理水平'
    },
  ]
  },
  name: 'powerIndustry',
  components: {
    resolution
  },
  data () {
    return {
      powerIndustry: {
        whyChoose: true,
        strength: {
          isGrey: true,
          title: '我们的优势',
          content: [{
            title: '视频多流',
            intro: '支持同一终端多路视频编码，可多角度呈现施工现场情况，并同步传输到控制中心',
            img: require('@/assets/resolution/powerIndustry/icon1.png')
          },{
            title: '录制回放',
            intro: '平台提供两种录制功能，可生成直播录制视频及云端回放链接',
            img: require('@/assets/resolution/powerIndustry/icon2.png')
          },{
            title: '高品质音画',
            intro: '最高4K编解码采集，业界领先的端到端60帧速率技术，超高音画体验',
            img: require('@/assets/resolution/powerIndustry/icon3.png')
          },{
            title: '结合AR/VR技术',
            intro: '可接入 AR /VR眼镜等设备，以第一视角呈现眼前景象，使远程检修、远程指导更高效',
            img: require('@/assets/resolution/powerIndustry/icon4.png')
          },]
        },
        banner: {
          title: '电力行业解决方案',
          desc: '针对电力行业，提供生产检修管理、智能监管等系统平台解决方案，帮助电网各级管理者掌握设备及其运维状态、提高电网在可靠性、技术、远程协同等方面的精益化管理水平',
          image: require('@/assets/resolution/powerIndustry/img1.png'),
          buttonText: '立即体验',
          buttonCallback: () => {
            window.open(CONSOLE_SITE_URL);
          }
        },
        use: {
          title: '使用场景',
          content: [{
            title: '生产检修管理',
            subtitle: '覆盖电力生产现场作业执行和业务管控过程，融合电网GIS、RFID、可视化展现、音视频技术，实现电网设备的集中生产、运维管理（包括设备台账，故障，缺陷，停电，检修计划等）',
            img: require('@/assets/resolution/powerIndustry/case1.png')
          }, {
            title: '智能监管',
            subtitle: '提升信息传递实时性、强化现场作业远程互动并结合AR/VR等技术，对现场作业违规行为监督、监测、远程指导',
            img: require('@/assets/resolution/powerIndustry/case2.png')
          }]
        },
        demonstration: {
          isGrey: true,
          choose: [13]
        }
      }
    }
  },
}
</script>

<style lang='less'>
.page-powerIndustry {}
</style>
